import { api } from "./customers";
export interface Customer {
  customerName: string;
  age: number;
  sex: string;
  spouseName: string;
  spouseAge: number;
  spouseSex: string;
  yearsMarried: string;
  source: string;
  status: boolean;
  customerStatus: string;
  serviceChoosen: string;
  customerId: number;
  appointmentDate: any;
  appointmentTime: any;
  id: number;
}
export interface DashboardCustomersResponse {
  status: string;
  message: string;
  total_count: number;
  total_pages: number;
  current_page: number;
  data: Customer[];
  per_page: number;
  prev_page: number;
  nextPage: number;
}
export interface AppinmentById {
  status: string;
  message: string;
  data: Customer[];
}
type DasboardCustomersResponse = DashboardCustomersResponse[];
type AppoinmentByidResponse = AppinmentById[];

export const ReminderApi = api.injectEndpoints({
  endpoints: (build) => ({
    getReminderList: build.query<DasboardCustomersResponse, any>({
      query: (pagi) => `reminder?page=${pagi?.pageNo}&fromDate=${
        pagi?.date?.startDate ? pagi?.date?.startDate : ""
      }&toDate=${pagi?.date?.endDate ? pagi?.date?.endDate : ""}&filter=${
        pagi?.filter
      }&name=${pagi?.name}`,
      providesTags: (result) =>
        result
          ? [
              ...result?.["data"]?.map(({ id }) => ({
                type: "DasboardCustomers" as const,
                id,
              })),
              { type: "DasboardCustomers", id: "LIST" },
            ]
          : [{ type: "DasboardCustomers", id: "LIST" }],
    }),
    addReminder: build.mutation<
      AppoinmentByidResponse,
      Partial<AppoinmentByidResponse>
    >({
      query: (body: any) => ({
        url: `reminder`,
        method: "POST",
        body,
      }),
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),
    deleteReminder: build.mutation<{ success: boolean; id: number }, number>({
      query(id) {
        return {
          url: `reminder/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),
  }),
});
export const {
  useGetReminderListQuery,
  useAddReminderMutation,
  useDeleteReminderMutation,
} = ReminderApi;
